import { InjectionToken } from '@angular/core';

import { Logger } from './logger.model';

export const LOGGERS = new InjectionToken<Logger[]>('LOGGERS');
